import React, { Component } from 'react';
import { leftMenuTypes, UserContext } from '../../constants';
import i18next from "../../i18n";
import { FeedbackForm } from '../FeedbackForm';
import { History } from '../helpers/History';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { viewFileFolderSystemFile } from '../ModalDialogsTemplates';
import { ListOfSearchResults } from '../listsOfAlfresco/ListOfSearchResults';
import { MenuItem } from './MenuItem';
export class LeftMenu extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            sections: null,
            loading: true,
            isMenuOpen: this.props.isOpen,
            search: ListOfSearchResults.getSearchStr(),
            expandedLink: ""
        };
        this.setExpandedLink = this.setExpandedLink.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.hideOverley = this.hideOverley.bind(this);
        this.keypressSearchInput = this.keypressSearchInput.bind(this);
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }
    setExpandedLink(link) {
        this.setState({
            expandedLink: link
        });
    }
    componentDidUpdate() {
        if (this.props.isOpen !== this.state.isMenuOpen) {
            this.setState({
                isMenuOpen: this.props.isOpen
            });
        }
    }
    toggleMenu() {
        this.setState({ isMenuOpen: !this.state.isMenuOpen })
    }
    hideOverley() {
        this.setState({ isMenuOpen: false })
        if (this.props.handleOpenLeftMenu) {
            this.props.handleOpenLeftMenu(false);
        }
    }
    componentDidMount() {
        this.getLeftMenu();
    }
    onSearch() {
        var searchInput = document.getElementById("main-search-input");
        if (searchInput.value) {
            this.setState({ search: searchInput.value });
            History.push('/search?search=' + searchInput.value);
        }
    }
    keypressSearchInput(e) {
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code === 13) { //Enter keycode                        
            e.preventDefault();
            this.onSearch();
        }
    }
    onSearchInputChange(e) {
        this.setState({ search: e.target.value });
    }
    render() {
        const { isMenuOpen, expandedLink } = this.state;
        const menuItems = this.state.sections?.menu?.menuItems;
        const copyright = this.state.sections?.copyright;
        const user = this.context;
        return (
            <>
                <div className={"left-menu menuBar" + (isMenuOpen === true ? ' open' : ' ')}>
                    {menuItems ? <div>
                        <div className="search-menu-block">
                            <img className="search-menu-icone" src="/img/MenuIcons/menu-search_v2.svg" onClick={this.onSearch} alt="" />
                            <input id="main-search-input" type="search" placeholder={i18next.t("searchInSections")} value={this.state.search} className="left-menu-search" onChange={this.onSearchInputChange} onKeyPress={this.keypressSearchInput} />
                        </div>
                        <div className="menu-line" />
                        <ul className="left-menu-items">
                            {menuItems && menuItems.map((item, index) =>
                                <MenuItem expandedLink={expandedLink} handlerSetExpandedLink={this.setExpandedLink}
                                    key={item.name ? item.name : index++} name={item.name} link={item.link} collapsed={!item.expanded} image={item.image} counter={item.counter} isRoot={true}
                                    type={item.type} menuItems={item.menuItems} />
                            )}
                            <Copyright copyright={copyright} />
                        </ul>
                        {user.companies && user.companies.length > 0 && user.companies[0].companyShortName && <span className="text">© {user.companies[0].companyShortName}</span>}
                    </div> : ""}
                </div>
                <div className={"overly" + (isMenuOpen === true ? ' open' : ' ')} onClick={this.hideOverley}></div>
                <div id="feedbackDialog"></div>
                <div id="userInstructionDialog"></div>
            </>
        );
    }
    async getLeftMenu() {
        const response = await fetch(`menu/getLeftmenu?${this.context.companies[0].companyKindValue}&countMunuItems=true`);
        if (response.ok) {
            const data = await response.json();
            this.setState({ sections: data });
        }
        else import("../ModalDialogsTemplates").then(templates => { templates.unknownErrorMessageDialog() });
    }
}
function CopyrightItem(props) {
    const renderClickHeandler = (item) => {
        let { name } = item;
        // eslint-disable-next-line default-case
        switch (name) {
            case 'feedbackLink':
                return (() => showModalDialog("loadingDialog", i18next.t("feedback"), "", <FeedbackForm onCloseHandler={() => { hideModalDialog("loadingDialog"); }} />, "feedPopup"));
            case 'userInstruction':
                return (() => viewFileFolderSystemFile(`/home/getUserInstructionFileContent`, i18next.t("userGuide")));
        }
        return (() => { });
    }
    const { link, image, type } = props;
    // eslint-disable-next-line default-case
    switch (type) {
        case leftMenuTypes.divider: return (<li className={"menu-line"}></li>);
        case leftMenuTypes.link:
            return (
                <li className={"left-menu-item-link"}>
                    {link?.url ?
                        <a href={link?.url} onClick={renderClickHeandler(props)}>{link?.text}</a> :
                        <a onClick={renderClickHeandler(props)}>{link?.text}</a>
                    }
                    {image?.path && <img className="main-menu-icone" alt="" src={image?.path} />}
                </li>
            );
    }
}
function Copyright(props) {
    const { copyright } = props;
    const { title, menuItems } = copyright;
    return (
        <>
            {title ? <li className={"left-menu-item-title "}>{title}</li> : ""}
            {menuItems?.map((item, index) =>
                <CopyrightItem key={item.name ? item.name : index++} name={item.name} link={item.link} image={item.image} isRoot={true} type={item.type} />
            )}
        </>
    );
}